import { Image, Stack } from "@chakra-ui/react";
import React from "react";
import { colors } from "../../styles";
import { getAdSrc } from "./adOrder";

interface IAdListItemProps {
    slotIndex: number;
}

function AdListItem({ slotIndex }: IAdListItemProps) {
    return (
        <Stack
            width={"100%"}
            overflow={"hidden"}
            spacing={0}
            borderRadius={"8px"}
        >
            <Image
                src={getAdSrc(slotIndex)}
                alt={"광고"}
                width={"100%"}
                height={"auto"}
                objectFit={"cover"}
                loading={"lazy"}
                sx={{ aspectRatio: "2172 / 724" }}
            />
        </Stack>
    );
}

export default React.memo(AdListItem);
